import { stringUtils } from '@pukka/common/utils';

import { BillingContent } from './BillingContent';

interface BillingPurchasedSlotProps {
  readonly loading?: boolean;
  readonly count: number;
}

function BillingPurchasedSlots({ loading, count }: BillingPurchasedSlotProps) {
  return (
    <BillingContent title="Extendable Purchased Slots">
      <BillingContent.Rows>
        <BillingContent.Row loading={loading} label="Number of Extendable Purchased Slots" icon="group">
          {stringUtils.pluralize(count, 'Slot')}
        </BillingContent.Row>
      </BillingContent.Rows>
    </BillingContent>
  );
}

export { BillingPurchasedSlots };
